import React from 'react';
import Input from 'src/app/atoms/Input/Input';
import SliderInput from 'src/app/atoms/Input/SliderInput';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { MoneyElement, SliderContainer } from './CalculatorInput.styles';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import HelpCircleHint from '../HelpCircleHint/HelpCircleHint';

export interface CalculatorInputProps {
  label: string;
  value: number | string;
  money?: boolean;
  onChange?: (value: number | string) => void;
  rightPlaceholder?: string;
  hint?: string;
  inputHint?: string;
  disabled?: boolean;
  type?: 'text' | 'number';
  max?: number;
  min?: number;
  slider?: {
    min: number;
    max: number;
    step: number;
    value?: number;
  };
}

const CalculatorInput = ({
  label,
  value,
  onChange,
  rightPlaceholder,
  hint,
  disabled = false,
  slider,
  max,
  min,
  type = 'text',
  money,
  inputHint,
}: CalculatorInputProps): JSX.Element => {
  return (
    <Input
      value={value.toString()}
      size='md'
      label={label}
      disabled={disabled}
      actionable={!slider}
      fontFamily='font-family-display'
      fontSize='font-size-display-sm'
      fontWeight='font-weight-semibold'
      lineHeight='line-height-display-sm'
      onChange={!slider && onChange ? onChange : undefined}
      type={type}
      labelBreakpoint='lg'
      hint={inputHint}
      max={max}
      min={min}
      leftElement={
        money && (
          <MoneyElement>
            <Typography
              type='heading'
              size='sm'
              fontWeight='font-weight-semibold'
            >
              $
            </Typography>
          </MoneyElement>
        )
      }
      rightElement={
        <Stack
          direction='row'
          gap='spacing-md'
        >
          {rightPlaceholder && (
            <Typography
              type='paragraph'
              size='md'
              color='text-placeholder'
              whiteSpace='nowrap'
            >
              {rightPlaceholder}
            </Typography>
          )}
          {hint && (
            <HelpCircleHint
              hint={hint}
              id={`${label}-hint`}
            />
          )}
        </Stack>
      }
      topRightElement={
        slider && (
          <Grid>
            <SliderContainer>
              <SliderInput
                value={slider.value}
                onChange={onChange}
                min={slider.min}
                max={slider.max}
                step={slider.step}
              />
            </SliderContainer>
          </Grid>
        )
      }
    />
  );
};

export default CalculatorInput;
